import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {GuiZone, GuiZoneCreateInfo} from '@catcore/types/api-v2';
import {extractDataFromProperty} from '@catcore/utils';
import * as componentActions from '@catdetails/actions/gui-zone';
import {FeatureUnitCreateInfo} from '@catmodules/models/feature-units/types';
import {Store} from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

/**
 * This service provides methods to create, update, read and delete a GuiZone.
 * It also provides methods to signal the application store if a GuiZone section is available.
 */
@Injectable()
export class GuiZoneService extends RestHttpService<GuiZone> {
  constructor(private store: Store<any>, restService: Restangular) {
    super('gui-zones', restService);
  }

  /**
   * Initiates the process to create a single GuiZone through the WebAPI
   * @param {FeatureUnitCreateInfo} item
   * @returns {Observable<any>}
   */
  create(item: GuiZoneCreateInfo): Observable<any> {
    const data = {
      name: item.name,
      short_name: item.shortName,
      zone_pa: item.zonePa,
      type: item.type,
      sortIndex: item.sortIndex,
      group_type: item.group_type,
      project: item.project._links.self.href,
    };
    if (item.parent) {
      data['parents'] = [item.parent._links.self.href];
    }
    return this.queryAll()
      .post(data);
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_GUI_ZONE_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_GUI_ZONE_DEACTIVATE});
  }

  extractGuiZonesFrom(guiZone: GuiZone){
    const lookupKey = 'children';
    return extractDataFromProperty(guiZone, lookupKey);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/services/gui-zone.service.ts